import { CockpitFilterConfig } from "../models/cockpit-filter-config.model";

export const VO_FILTER_CONFIG: CockpitFilterConfig[] = [
  {
    path: 'vo',
    defaultFilters: [],
    keepFilters: [],
  }
];

